import { useTranslation } from '@shared/localization';
import { useEffect } from 'react';

import {
  disableUIBlocker,
  PageLayout,
  PrimaryButton,
} from '@/components/common';
import { AlertWarning } from '@/components/common/alerts';
import PaymentStore from '@/services/payments/PaymentStore';
import { redirect } from '@/utils/redirect';

//TODO: check if we need this session component because expiration should not happen

export function SessionExpired() {
  const { t } = useTranslation();
  const url = PaymentStore.cancelUrl;

  useEffect(() => {
    disableUIBlocker();
  }, []);

  return (
    <PageLayout
      headerDescription={t('Order: {{orderNumber}}', {
        orderNumber: PaymentStore.orderNumber,
      })}
    >
      <div className="flex flex-col items-center text-center m-sm md:m-md bg-white border-[1px] border-silver-700 rounded-xl p-md">
        <AlertWarning title={t('Your session expired!')} />
      </div>

      {url !== undefined && (
        <div className="flex justify-center m-sm md:m-md">
          <PrimaryButton
            onClick={() => {
              redirect(url);
            }}
          >
            {t('Start Again')}
          </PrimaryButton>
        </div>
      )}
    </PageLayout>
  );
}
